/* Stylesheet */

.dropdown_item {
  --padding-start: 0px;
  display: flex;
  align-items: center;
  max-height: 42px;
  color: var(--ion-color-text-secondary);
  --background: transparent;
  --color-hover: var(--ion-color-text-secondary);
  --color-activated: var(--ion-color-text-secondary);

  .icon {
    margin: 0px 12px 0px 12px;
    height: 14px;
    width: 14px;
    color: var(--ion-color-text-secondary);
  }

  .label {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
  }
}

/* Media Queries */
@media screen and (min-width: 1600px) {
  .dropdown_item {
    .label {
      font-size: 1rem;
    }
  }
}
